import { ErrorBoundary } from '@/components/layout/ErrorBoundary';
import { Providers } from './Providers';
import { AppShell } from './AppShell';

export function App() {
  return (
    <ErrorBoundary>
      <Providers>
        <AppShell />
      </Providers>
    </ErrorBoundary>
  );
}
